<template>

    <pending></pending>

</template>

<script>

    import Pending from "../../components/Images/Pending";

    export default {

        components: {
            Pending,
        },

        metaInfo: {
            title:'Pending Images',
        },

        name:'ImagesPending',

    }

</script>
